export default "__VITE_ASSET__Bfv0Qws4__"